// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { node } from "~/util/dom";
import { store } from "~/state/store";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";

/**
 * Trida pro zobrazeni markeru s pocasim nad routou
 */
export default class RouteWeatherMarkers {
	_storeUnsubscribe: Unsubscribe;

	/**
	 * konstruktor
	 * @param  {Object} geometry [Mapy.Route.Geometry]
	 * @return {[type]}          [description]
	 */
	constructor(geometry) {
		this._weather = {};
		this.MIN_PIXELS_DISTANCE = {
			"18": 400,
			"10": 180
		};
		this._MIN_PADDING = 100;
		this._data = {};
		this._defineZooms = [];
		this._minPixelsSpace = {};
		this._prevZoom = 0;
		this._geometry = geometry;
		this._startMarker = null;
		this._endMarker = null;
		this._geometryPixels = [];
		this._mLayer = Scene.createLayerMarker("weather-markers");
		this._markers = [];
		this._items = [];
		this._svgCache = {};
		this._actualType = "temp";
		this._url = CONFIG.requestUrl + "/weather";
		Scene.addLayer(this._mLayer).enable();
		this._storeUnsubscribe = null;
	}

	/**
	 * destroy - uklidim po sobe
	 */
	destroy() {
		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;
		this._clear();
		this._item = [];
		this._mLayer.disable();
		Scene.removeLayer(this._mLayer);
	}

	/**
	 * nastaveni dat
	 * @param  {Object} weather objekt s pocasim
	 */
	set data(weather) {
		this._weather = weather;

		if (!("entries" in this._weather) || ("entries" in this._weather && this._weather.entries.length < 2)) {
			this._clear();
			return;
		}

		this._countData();
		this._addFixedMarkers();
		this._mapRedraw();

		this._storeUnsubscribe?.();
		const wt = watch(store.getState, "map", watchCoordinates);

		this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this._mapRedraw();
			}
		}));
	}

	/**
	 * zobrazeni markeru
	 */
	show() {
		Scene.addLayer(this._mLayer).enable();

		// pokud nemame - preskocime
		if (!this._startMarker || this._storeUnsubscribe) return;

		this._storeUnsubscribe?.();
		this._mapRedraw();
		const wt = watch(store.getState, "map", watchCoordinates);

		this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this._mapRedraw();
			}
		}));
	}

	/**
	 * skryti markeru
	 */
	hide() {
		this._mLayer.disable();
		Scene.removeLayer(this._mLayer);
		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;
	}

	/**
	 * nastaveni typu pro zobrazeni obsahu
	 * @param  {String} type typ, ktery se ma v bubline zobrazit
	 */
	set type(type) {
		if (!type) {
			return;
		}

		this._actualType = type;

		this._items.forEach(item => {
			item.marker.innerElement = item[type];
		});

		this._startMarker.marker.innerElement = this._startMarker[type];
		this._endMarker.marker.innerElement = this._endMarker[type];
	}

	/**
	 * prevede string na objekt Date
	 * @param  {String} str datum a cas ve formatu 'yyyy-mm-ddThh:mm'
	 * @return {Date}     objekt Date se zadanym casem
	 */
	getTime(str) {
		let parts = str.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
		let dateObj = parts.length == 6 ? new Date(parts[1], parts[2] - 1, parts[3], parts[4], parts[5]) : new Date();

		return dateObj;
	}

	_clear() {
		this._mLayer.removeAll();

		while (this._markers.length) {
			this._markers.shift().destroy();
		}

		if (this._startMarker) {
			this._startMarker.marker.destroy();
		}

		if (this._endMarker) {
			this._endMarker.marker.destroy();
		}
	}

	/**
	 * napocitani dat
	 * @private
	 */
	_countData() {
		let coords = this._geometry.getCoords();
		let len = Mapy.Util.IP.countDistances(coords);
		let actIndex = 0;
		let from = null;
		let to = null;
		let fromDist = 0;
		let toDist = -1;
		let diffDist = 0;
		let fromTime = 0;
		let toTime = 0;

		this._data.interpolation = [];

		coords.forEach((c, i) => {
			if (len[i] > toDist && this._weather.entries[actIndex+1]) {
				from = this._weather.entries[actIndex];
				to = this._weather.entries[actIndex+1];
				fromTime = this.getTime(from.localDate + "T" + from.localTime).getTime();
				toTime = this.getTime(to.localDate + "T" + to.localTime).getTime();
				fromDist = from.relPos * len[len.length-1];
				toDist = to.relPos * len[len.length-1];
				diffDist = toDist - fromDist;
				actIndex++;

			}

			let d = len[i] - fromDist;
			let frac = d == 0 ? 0 : d / diffDist;
			let time = (toTime - fromTime) * frac + fromTime;

			this._data.interpolation.push({
				temp: (to.temp - from.temp) * frac + from.temp,
				coords: c,
				time,
				windSpeed: (to.wind - from.wind) * frac + from.wind,
				windDirection: this._windInterpolation(from.windDir, to.windDir, frac),
				windCategory: d < diffDist/2 ? from.windCategory : to.windCategory,
				precip: (to.precip - from.precip) * frac + from.precip,
				precipCategory: d < diffDist/2 ? from.precipCategory : to.precipCategory,
				precipType: d < diffDist/2 ? from.precipType : to.precipType,
				snowPrecip: (to.snowPrecip - from.snowPrecip) * frac + from.snowPrecip,
				snowPrecipCategory: d < diffDist/2 ? from.snowPrecipCategory : to.snowPrecipCategory,
				icon: d < diffDist/2 ? from.icon : to.icon,
				isDay: this._checkSunrise(d < diffDist/2 ? from : to, time)
			});
		});

		let keys = Object.keys(this.MIN_PIXELS_DISTANCE);

		let countSteps = (start, end) => {
			let startSpace = this.MIN_PIXELS_DISTANCE[start];
			let endSpace = this.MIN_PIXELS_DISTANCE[end];
			let steps = end - start;

			this._defineZooms.push(start);
			this._minPixelsSpace[start] = startSpace;
			this._minPixelsSpace[end] = endSpace;

			if (steps <= 0) { return; }

			let step = (endSpace - startSpace) / steps;

			for (let i = 1; i < steps; i++) {
				this._minPixelsSpace[start+i] = startSpace + step * i;
				this._defineZooms.push(start+i);
			}
			this._defineZooms.push(end);
		}

		let zNumbers = keys.map(z => {
			return parseInt(z);
		});
		zNumbers.sort((a, b) => { return a - b; })

		for (let i = 0; i < zNumbers.length-1; i++) {
			countSteps(zNumbers[i], zNumbers[i+1]);
		}
	}

	/**
	 * po prekresleni mapy potrebujeme napozicovat markery
	 * @private
	 */
	_mapRedraw() {
		let geometries = this._geometry.geometries;
		let indexes = [];
		const { zoom } = store.getState().map;

		this._mLayer.removeAll();
		while (this._markers.length) {
			this._markers.shift().destroy();
		}

		this._item = [];

		if (!geometries || !geometries.length) { return; }

		this._geometryPixels = this._geometry.getPixels(true);

		if (this._prevZoom != zoom) {
			this._data.distance = [];
			this._data.len = [];
			let prev = 0;
			this._geometryPixels.forEach((px, key) => {
				let d = key != 0 ? px.distance(this._geometryPixels[key-1]) : 0;
				this._data.distance.push(d);
				this._data.len.push(prev + d);
				prev += d;
			});

			this._data.half = Math.round(prev / 2);

			this._prevZoom = zoom;
		}

		this._addMarkers();
	}

	/**
	 * pridani markeru pro start a cil, ta jsou vzdy
	 * @private
	 */
	_addFixedMarkers() {
		let data = this._data.interpolation[0];
		let tempElm = this._getTempElm(this._data.interpolation[0], Mapy.Util.formatNumber(data.temp, 1), data.time);
		let precipElm = this._getPrecipElm(data, data.precip, data.snowPrecip, data.time);
		let windElm = this._getWindElm(data, {
			speed: data.windSpeed,
			direction: data.windDirection,
		}, data.time);

		let startM = Scene.createMarkerBubble(data.coords, null, { className: "route-weather" });

		this._startMarker = {
			marker: startM,
			temp: tempElm,
			precip: precipElm,
			wind: windElm
		};

		startM.innerElement = this._startMarker[this._actualType];

		let iLen = this._data.interpolation.length-1;
		data = this._data.interpolation[iLen];

		tempElm = this._getTempElm(this._data.interpolation[iLen], Mapy.Util.formatNumber(data.temp, 1), data.time);
		precipElm = this._getPrecipElm(data, data.precip, data.snowPrecip, data.time);
		windElm = this._getWindElm(data, {
			speed: data.windSpeed,
			direction: data.windDirection,
		}, data.time);

		let endM = Scene.createMarkerBubble(data.coords, null, {
			elm: tempElm,
			className: "route-weather"
		});

		this._endMarker = {
			marker: endM,
			temp: tempElm,
			precip: precipElm,
			wind: windElm
		};

		endM.innerElement = this._endMarker[this._actualType];
	}

	/**
	 * pridani ostatnich markeru, pokud se vejdou
	 * @private
	 */
	_addMarkers() {
		let markers = [];
		let coords = this._geometry.getCoords();
		let minPixelsSpace = this._getMinPixelsSpace();
		let half = this._data.half;
		let next = half % minPixelsSpace;
		let prev = 0;
		let indxs = [];
		let indexes = this._geometry.getIndexes();

		if (next < this._MIN_PADDING) {
			next += minPixelsSpace;
		}

		for (let x = 0; x < indexes.length; x++) {
			indxs = indxs.concat(indexes[x]);
		}

		let startFrom = 60;
		let startTo = 180;
		let endFrom = 60;
		let endTo = 180;

		if (this._startMarker && this._startMarker.marker.getCoords().distance(this._endMarker.marker.getCoords()) < 10) {
			startFrom = 81;
			endTo = 27;
		}

		if (this._startMarker) {
			this._startMarker.marker.resolveColision(this._geometryPixels, startTo, startFrom);
			this._endMarker.marker.resolveColision(this._geometryPixels, endTo, endFrom);
		}

		this._data.len.forEach((l, i) => {
			if (l > next && l < this._data.len[this._data.len.length-1] - this._MIN_PADDING) {
				if (indxs.indexOf(i) > -1) {
					let nextDiff = next-prev;
					let prevDiff = l-prev;
					let item = this._buildItem(i, nextDiff, prevDiff, coords[i-1], coords[i]);

					item.marker.innerElement = item[this._actualType];

					markers.push(item.marker);
					this._items.push(item);

					next = l;
				}

				next += minPixelsSpace;
			}

			prev = l;
		});

		this._mLayer.addMarker(markers);
		if (this._startMarker) {
			this._mLayer.addMarker([this._startMarker.marker, this._endMarker.marker]);
		}
		this._markers = markers;
	}

	/**
	 * vypocet minimalni pixelove vzdalenosti bodu na trase, kam je mozne pripichnout marker
	 * @private
	 * @return {[type]} [description]
	 */
	_getMinPixelsSpace() {
		const { zoom } = store.getState().map;
		let minPixelsSpace = this._minPixelsSpace[this._defineZooms[0]];


		if (zoom >= this._defineZooms[this._defineZooms.length-1]) {
			minPixelsSpace = this._minPixelsSpace[this._defineZooms[this._defineZooms.length-1]];
		}

		if (zoom < this._defineZooms[this._defineZooms.length-1] && zoom > this._defineZooms[0]) {
			minPixelsSpace = this._minPixelsSpace[zoom];
		}

		return minPixelsSpace;
	}

	/**
	 * vytvoreni elementu, kteryma se naplni marker
	 * @private
	 * @param  {Integer} i        index
	 * @param  {Float} nextDiff vzdalenost
	 * @param  {Float} prevDiff vzdalenost
	 * @param  {Object} cPrev    souradnice predchoziho nejblizsiho bodu
	 * @param  {Object} cActual  souradnice aktualne zpracovavaneho bodu
	 * @return {Object}          objekt s markerem a elementy pro naplneni bubliny
	 */
	_buildItem(i, nextDiff, prevDiff, cPrev, cActual) {
		let c = Mapy.Util.IP.getCoordAtDistance(nextDiff, [cPrev, cActual], [0, prevDiff]);
		let entry = nextDiff/prevDiff > 0.5 ? this._data.interpolation[i] : this._data.interpolation[i-1];
		//time
		let timeDiff = this._data.interpolation[i].time - this._data.interpolation[i-1].time;
		let time = (nextDiff/prevDiff)*timeDiff + this._data.interpolation[i-1].time;

		//temp
		let tempDiff = this._data.interpolation[i].temp - this._data.interpolation[i-1].temp;
		let temp = Mapy.Util.formatNumber((nextDiff/prevDiff)*tempDiff + this._data.interpolation[i-1].temp, 1);
		let tempElm = this._getTempElm(entry, temp, time);

		//precip
		let precipDiff = this._data.interpolation[i].precip - this._data.interpolation[i-1].precip;
		let precip = (nextDiff/prevDiff)*precipDiff + this._data.interpolation[i-1].precip;
		let snowPrecipDiff = this._data.interpolation[i-1].snowPrecip - this._data.interpolation[i].snowPrecip;
		let snowPrecip = (nextDiff/prevDiff)*snowPrecipDiff + this._data.interpolation[i].snowPrecip;
		let precipElm = this._getPrecipElm(entry, precip, snowPrecip, time);

		//wind
		let windDiff = this._data.interpolation[i].windSpeed - this._data.interpolation[i-1].windSpeed;
		let windSpeed = (nextDiff/prevDiff)*windDiff + this._data.interpolation[i-1].windSpeed;
		let windDirection = this._windInterpolation(this._data.interpolation[i-1].windDirection, this._data.interpolation[i].windDirection, nextDiff/prevDiff);
		let wind = {
			speed: windSpeed,
			direction: windDirection
		}

		let windElm = this._getWindElm(entry, wind, time);

		let marker = Scene.createMarkerBubble(c, null, { className: "route-weather" });

		marker.resolveColision(this._geometryPixels, 180);

		return {
			marker,
			temp: tempElm,
			wind: windElm,
			precip: precipElm
		};
	}

	/**
	 * buildeni elementu s teplotou
	 * @private
	 * @param  {Object} entry hodnoty z backendu
	 * @param  {Float} temp  teplota
	 * @param  {Float} time  cas v milisekundach
	 * @return {Element}       vybuildeny element
	 */
	_getTempElm(entry, temp, time) {
		let tempElm = node("div");
		let svgData = this._weather.stateIcons[entry.icon] || { urlNight: "", url: "", tooltip: "" };
		let icon = this._getSVG(!entry.isDay && svgData.urlNight ? svgData.urlNight : svgData.url, svgData.tooltip, svgCover => {
			let svg = svgCover.querySelector("svg");
			svg.classList.add("icon");
		});
		let span = node("span", {}, `${temp}°`);
		let spanT = node("span", { className: "time" }, this._formatTime(time));

		tempElm.appendChild(icon);
		tempElm.appendChild(span);
		tempElm.appendChild(spanT);

		return tempElm;
	}

	/**
	 * bildeni elementu se srazkama
	 * @private
	 * @param  {Object} entry hodnoty z backendu
	 * @param  {Float} precip     srazky
	 * @param  {Int} snowPrecip zda se jedna o snih
	 * @param  {Float} time  cas v milisekundach
	 * @return {Element}            vybuildeny element
	 */
	_getPrecipElm(entry, precip, snowPrecip, time) {
		let isSnow = false;
		let showPrecip = false;
		let rainCat = this._weather.categories.precip || [];
		let snowCat = this._weather.categories.snowPrecip || [];
		let precipElm = node("div", { className: "precip" });

		precip = Math.round(precip*10)/10;

		// 5 snih a 6 vlhky snih
		if ([5, 6].indexOf(entry.precipType) != -1) {
			isSnow = true;
		}
		// 1 dest, 3 mrznouci dest, 7 dest se snehem, 8 kroupy
		else if ([1, 3, 5, 6, 7, 8].indexOf(entry.precipType) != -1) {
			showPrecip = true;
		}

		if (precip < 0.1) {
			showPrecip = false;
		}

		if (showPrecip) {
			let precipCat = isSnow ? entry.snowPrecipCategory : entry.precipCategory;

			// nezobrazujeme 0 kategorie
			if (precipCat > 0) {
				let precipData = isSnow ? snowCat[entry.snowPrecipCategory] : rainCat[entry.precipCategory];
				let icon = this._getSVG(precipData.icon, precipData.tooltip, svgCover => {
					let svg = svgCover.querySelector("svg");
					let path = svg.querySelector("path");
					svg.classList.add("icon");
					path.setAttribute("fill", "");
				});
				let span = node("span", {}, this._formatPrecip(isSnow ? snowPrecip : precip, isSnow));

				precipElm.appendChild(icon);
				precipElm.appendChild(span);
			}
		}
		else {
			precipElm.appendChild(node("span", { className: "no-precip" }, _("weather.graph.noPrecip")));
		}

		let spanT = node("span", { className: "time" }, this._formatTime(time));
		precipElm.appendChild(spanT);

		return precipElm;
	}

	/**
	 * buildeni elementu s vetrem
	 * @private
	 * @param  {Object} entry hodnoty z backendu
	 * @param  {Float} wind  vitr
	 * @param  {Float} time  cas v milisekundach
	 * @return {Element}       vybuildeny element s vetrem
	 */
	_getWindElm(entry, wind, time) {
		let windElm = node("div");
		let windCat = this._weather.categories.wind || [];
		let windData = windCat[entry.windCategory];
		let icon = this._getSVG(windData.icon, windData.tooltip, svgCover => {
			let svg = svgCover.querySelector("svg");
			svg.classList.add("icon");
			svg.style.transform = `rotate(${wind.direction}deg)`;
		});

		let span = node("span", {}, `${Mapy.Util.formatNumber(wind.speed, 1)} m/s`);
		let spanT = node("span", { className: "time" }, this._formatTime(time));

		windElm.appendChild(icon);
		windElm.appendChild(span);
		windElm.appendChild(spanT);

		return windElm;
	}

	/**
	 * formatovani casu
	 * @private
	 * @param  {Float} time cas v milisekundach
	 * @return {String}      naformatovany cas
	 */
	_formatTime(time) {
		let now = new Date();
		let datetime = new Date(time);
		let day = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

		return `${now.getDate() != datetime.getDate() ? `${_("calendar.shortDays."+day[datetime.getDay()])} ` : ``}${datetime.getHours().toString().lpad("0", 2)}:${datetime.getMinutes().toString().lpad("0", 2)}`;
	}

	/**
	 * nacteni a vytvoreni elementu s ikonou
	 * @param  {String}   src     url ikony
	 * @param  {String}   tooltip
	 * @param  {Function} cb      navratova funkce po nacteni
	 * @return {Element}          Element, do ktereho se vlozi ikona po nacteni
	 */
	_getSVG(src, tooltip = "", cb) {
		let svgCover = node("div", { className: "icon", title: tooltip });

		if (!(src in this._svgCache)) {
			this._svgCache[src] = new Promise(resolve => {
				Mapy.Util.request(this._url + src).promise.then(reqObj => {
					// nacetlo se svg
					resolve(reqObj.data);
				}, e => {
					// eslint-disable-next-line no-console
					console.error(e);
				});
			});
		}

		this._svgCache[src].then(data => {
			// po nacteni dat
			svgCover.innerHTML = data;

			// nejaka dalsi transformace
			if (typeof cb === "function") {
				cb(svgCover);
			}
		}, () => {});

		return svgCover;
	}

	/**
	 * foramtovani srazek
	 * @param  {Float}  precip srazky
	 * @param  {Boolean} isSnow zda se jedna o snih
	 * @return {String}
	 */
	_formatPrecip(precip, isSnow) {
		let value = (precip >= 10 || precip % 1 <= 0.01 ? Math.floor(precip) : precip.toFixed(1)).toString().replace(".", ",");
		let unit = isSnow ? "cm/h" : "mm/h";

		return (`${value} ${unit}`);
	}

	/**
	 * interpolace smeru vetru
	 * @param  {Float} from z uhlu
	 * @param  {Float} to   do uhlu
	 * @param  {Float} frac frakce
	 * @return {Float}      vypocitany uhel
	 */
	_windInterpolation(from, to, frac) {
		if (from != to) {
			let u1 = [Math.sin(from*Math.PI/180), Math.cos(from*Math.PI/180)];
			let u2 = [Math.sin(to*Math.PI/180), Math.cos(to*Math.PI/180)];
			let u_weight = [u1[0] * (1-frac) + u2[0] * frac, u1[1] * (1-frac) + u2[1] * frac]
			let angle = Math.atan2(u_weight[0], u_weight[1])

			return Math.round(angle*180/Math.PI);
		}
		else {
			return from;
		}
	}

	_checkSunrise(entry, time) {
		let from = entry.sunriseTs + (new Date()).getTimezoneOffset()*60000+entry.TZoffsetMin*60000;
		let to = entry.sunsetTs + (new Date()).getTimezoneOffset()*60000+entry.TZoffsetMin*60000;
		time = time;

		return time >= from && time < to;
	}
}
